import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import GifItem from "./GifItem";

const CreatePost = ({
  addPost,
  setcreatePostOpen,
  user,
  profile,
  channelid,
  getGifs,
  getGifsSearch,
  gifs,
}) => {
  const [Post, setPost] = useState({ text: "", photo: "", video: "", gif: "" });
  const [isPinnedPost, setIsPinnedPost] = useState(false);
  const [icon, setIcon] = useState({ text: true, photo: false, video: false });
  const [imageFile, setImageFile] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [showGIFs, setshowGIFs] = useState(false);
  const [text, setText] = useState("");
  const [videoVolume, setVideoVolume] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);

  let textPost = Post.text;

  const maxLength = 100;

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  return (
    <Fragment>
      <div className="create-post-overlay">
        <form
          className="create-post-box"
          onSubmit={(e) => {
            e.preventDefault();
            if (
              Post.text !== "" ||
              Post.photo !== "" ||
              Post.video !== "" ||
              Post.gif !== ""
            ) {
              addPost(Post, channelid, isPinnedPost);
              setPost("");
              setcreatePostOpen(false);
            }
          }}
        >
          <div className="create-post-avi-text">
            <div className="create-post-avi-container">
              <img
                className="create-post-avi"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  user && user.avatar
                }`}
                alt="avatar"
              />
            </div>
            <div className="create-post-text-container">
              <div>
                {icon.text && (
                  <div className="relative-textarea-container">
                    <textarea
                      className="create-post-text-alt"
                      name="text"
                      maxLength={100}
                      value={Post.text}
                      onChange={(e) => {
                        setPost({ ...Post, text: e.target.value });
                      }}
                      placeholder="What would you like to say?"
                    ></textarea>
                    <p className="white character-counter-alt">
                      {Post.text.split("").length}/{maxLength} characters
                    </p>
                  </div>
                )}
                {imageFile === "" && icon.photo && (
                  <div className="upload-container">
                    <label
                      htmlFor="profilephotopost"
                      className="setup-image-container"
                    >
                      <div
                        className={`create-post-icons-alt ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        <i
                          className={`fas fa-plus fa-lg ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-camera-retro fa-4x mx-5 ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                      </div>
                    </label>
                    <input
                      type="file"
                      name="profilephotopost"
                      id="profilephotopost"
                      className="file-upload"
                      multiple
                      onChange={(e) => {
                        setPost({
                          ...Post,
                          photo: e.target.files[0],
                        });
                        setImageFile(URL.createObjectURL(e.target.files[0]));
                      }}
                    />
                  </div>
                )}
                {imageFile !== "" && icon.photo && (
                  <img
                    src={imageFile}
                    alt="upload-file-avatar"
                    className="upload-file"
                  />
                )}
                {videoFile === "" && icon.video && (
                  <div className="upload-container">
                    <label
                      htmlFor="profilevideopost"
                      className="setup-image-container"
                    >
                      <div
                        className={`create-post-icons-alt ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        <i
                          className={`fas fa-plus fa-lg ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        <i
                          className={`fas fa-video fa-4x mx-5 ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                      </div>
                    </label>
                    <input
                      type="file"
                      name="profilevideopost"
                      id="profilevideopost"
                      className="file-upload"
                      multiple
                      onChange={(e) => {
                        setPost({
                          ...Post,
                          video: e.target.files[0],
                        });
                        setVideoFile(URL.createObjectURL(e.target.files[0]));
                      }}
                    />
                  </div>
                )}
                {videoFile !== "" && icon.video && (
                  <video
                    onClick={() => {
                      if (videoVolume) {
                        setVideoVolume(false);
                      } else {
                        setVideoVolume(true);
                      }
                    }}
                    src={videoFile}
                    muted={videoVolume ? true : false}
                    autoPlay
                    loop
                    className="upload-file"
                  ></video>
                )}
                {showGIFs && Post.gif === "" && icon.gif && (
                  <div className="comment-gif-input-hidden-post">
                    <div className="giphy-container-post">
                      <div className="wrap-container-alt">
                        <div
                          className={`powered-by-giphy-alt ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Powered By
                        </div>
                        <img
                          src={
                            "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                          }
                          style={{
                            width: "80px",
                            margin: "0px 10px",
                          }}
                          alt="logo"
                        />
                      </div>
                      <div
                        className="gifs-alt"
                        id={`${
                          user && user.role === "innovator"
                            ? "green-scroll"
                            : user && user.role === "mentor"
                            ? "red-scroll"
                            : user && user.role === "employer"
                            ? "blue-scroll"
                            : ""
                        }`}
                      >
                        {!gifSearch &&
                          gifs.map((gif) => (
                            <div
                              className="gif-choice"
                              onClick={(e) => {
                                setPost({
                                  ...Post,
                                  gif: e.target.attributes["src"].value,
                                });
                              }}
                            >
                              <GifItem key={gif.id} gif={gif} />
                            </div>
                          ))}
                        {gifSearch &&
                          gifs.map((gif) => (
                            <div
                              className="gif-choice"
                              onClick={(e) => {
                                setPost({
                                  ...Post,
                                  gif: e.target.attributes["src"].value,
                                });
                              }}
                            >
                              <GifItem key={gif.id} gif={gif} />
                            </div>
                          ))}
                      </div>
                      <form
                        className="gif-input-hidden"
                        onSubmit={(e) => {
                          e.preventDefault();
                          getGifsSearch({ text });
                          setText("");
                          setGifSearch(true);
                        }}
                      >
                        <input
                          type="text"
                          className="gif-input"
                          name="text"
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          placeholder="Search for GIFs..."
                        />
                        <button
                          type="submit"
                          onSubmit={(e) => {
                            e.preventDefault();
                            getGifsSearch({ text });
                            setText("");
                            setGifSearch(true);
                            setshowGIFs(false);
                          }}
                          className={`gif-input-button ${
                            user && user.role === "innovator"
                              ? "background-green"
                              : user && user.role === "mentor"
                              ? "background-red"
                              : user && user.role === "employer"
                              ? "background-blue"
                              : ""
                          }`}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>
                )}
                {Post.gif !== "" && icon.gif && (
                  <div className="flex-only-container">
                    <img
                      src={Post.gif}
                      alt="upload-file-avatar"
                      className="upload-file"
                    />
                    <i
                      className="far fa-times fa-lg selected-gif-x-alt"
                      onClick={() => {
                        setPost({ ...Post, gif: "" });
                      }}
                    ></i>
                  </div>
                )}
              </div>
            </div>
            <div className="mx-20">
              <i
                className="fas fa-times fa-3x clear"
                onClick={() => setcreatePostOpen(false)}
              ></i>
            </div>
          </div>
          {Post.photo !== "" && (
            <div className="remove-file-container">
              <div
                onClick={() => {
                  setPost({
                    text: textPost,
                    photo: "",
                    video: "",
                    gif: "",
                  });
                  setImageFile("");
                  setVideoFile("");
                }}
                className="remove-file background-dark-black"
              >
                <i
                  class={`fa-regular fa-file-excel fa-lg mr-10 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>{" "}
                Remove File
              </div>
            </div>
          )}
          {Post.video !== "" && (
            <div className="remove-file-container">
              <div
                onClick={() => {
                  setPost({
                    text: textPost,
                    photo: "",
                    video: "",
                    gif: "",
                  });
                  setImageFile("");
                  setVideoFile("");
                }}
                className="remove-file background-dark-black"
              >
                <i
                  class={`fa-regular fa-file-excel fa-lg mr-10 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>{" "}
                Remove File
              </div>
            </div>
          )}
          <div className="post-type-container">
            <p
              onClick={() =>
                setIcon({ text: true, photo: false, video: false, gif: false })
              }
              className={`icon-wrap ${
                icon.text ? "background-black-light" : ""
              }`}
            >
              <i
                class={`fa-solid fa-pencil fa-2x ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
            </p>
            {Post.video === "" && Post.gif === "" && (
              <p
                onClick={() =>
                  setIcon({
                    text: false,
                    photo: true,
                    video: false,
                    gif: false,
                  })
                }
                className={`icon-wrap ${
                  icon.photo ? "background-black-light" : ""
                }`}
              >
                <i
                  class={`fa-solid fa-image fa-2x ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
              </p>
            )}
            {Post.photo === "" && Post.gif === "" && (
              <p
                onClick={() =>
                  setIcon({
                    text: false,
                    photo: false,
                    video: true,
                    gif: false,
                  })
                }
                className={`icon-wrap ${
                  icon.video ? "background-black-light" : ""
                }`}
              >
                <i
                  class={`fa-solid fa-film fa-2x ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
              </p>
            )}
            {Post.video === "" &&
              Post.photo === "" &&
              user.founding_supporter_type !== "" &&
              user.founding_supporter_type !== "Good" && (
                <p
                  onClick={() => {
                    setshowGIFs(true);
                    setIcon({
                      text: false,
                      photo: false,
                      video: false,
                      gif: true,
                    });
                  }}
                  className={`icon-wrap ${
                    icon.gif && user && user.role === "innovator"
                      ? "background-black-light green"
                      : icon.gif && user && user.role === "mentor"
                      ? "background-black-light red"
                      : icon.gif && user && user.role === "employer"
                      ? "background-black-light blue"
                      : !icon.gif && user && user.role === "innovator"
                      ? "green"
                      : !icon.gif && user && user.role === "mentor"
                      ? "red"
                      : !icon.gif && user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  <i
                    class={`fa-solid fa-photo-film fa-2x mr-5 ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                  GIF
                </p>
              )}
          </div>
          {user.channelid === profile.channelid && (
            <div className="checkboxes-post">
              <input
                className="mx-5 checkbox"
                type="checkbox"
                checked={isPinnedPost}
                onChange={() => {
                  if (isPinnedPost) {
                    setIsPinnedPost(false);
                  } else {
                    setIsPinnedPost(true);
                  }
                }}
              ></input>
              <span
                className={`${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                } bold mx-5`}
              >
                <i
                  class={`fa-solid fa-map-pin mr-5 ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
                Pin Post
              </span>
            </div>
          )}
          <div className="create-post-button-container">
            <button
              className={`create-post-button-alt ${
                user && user.role === "innovator"
                  ? "background-green"
                  : user && user.role === "mentor"
                  ? "background-red"
                  : "background-blue"
              }`}
            >
              <i className="far fa-edit mx-5"></i>Create Post
            </button>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

CreatePost.propTypes = {
  auth: PropTypes.object.isRequired,
  addPost: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(CreatePost);
